import { useParams } from "react-router";
import styled from "styled-components";
import { useScript } from "usehooks-ts";

import AppHeader from "../components/AppHeader";

import type { ElementType } from "react";


const StyledAppComponent = styled.div`
    height: 100vh;
    min-height: 100%;
    padding-top: 48px;

    a {
        display: block;
        margin: 5px 20px;
    }
`;

export default function AppComponent() {
    const { appName } = useParams();

    // a custom element registered by the remote component script, so not a known intrinsic tag
    const AppElement = `${ appName }-console` as unknown as ElementType;

    useScript(`https://components.bimproject.cloud/${ appName }-console/main/component.js`);

    return (
        <StyledAppComponent>
            <AppHeader />
            <AppElement
                path={ `/${ appName }` }
            />
        </StyledAppComponent>
    );
}
